module.exports = __webpack_public_path__ + "media/images/breadcrumb-arrow-685c6d8d4085125470311fd6fdaa59b7.svg";